import { render, staticRenderFns } from "./Curriculo_Anexo.vue?vue&type=template&id=11bcb1bc&scoped=true"
import script from "./Curriculo_Anexo.vue?vue&type=script&lang=js"
export * from "./Curriculo_Anexo.vue?vue&type=script&lang=js"
import style0 from "./Curriculo_Anexo.vue?vue&type=style&index=0&id=11bcb1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bcb1bc",
  null
  
)

export default component.exports